import React from 'react';
import ChangePasswordForm from './Components/ChangePasswordForm';

const ChangePasswordPage = () => {
  return (
    <div className="w-full h-full">
      <div className="pb-1">
        <ChangePasswordForm />
      </div>
    </div>
  );
};

export default ChangePasswordPage;
